import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContentState } from '../store/state/content.state';
import { LoaderService } from './loader.service';
import { Message } from '../models/message.model';
import { Modal } from '../models/modal.model';
import { ERROR_NO_LABELS, LANGUAGE_DEFAULT } from '../app.constants';
import { HippoContentService } from './hippo-content.service';
import { AuthService } from './auth.service';
import { InformationMessage } from '../models/information-message.model';

@Injectable({
    providedIn: 'root'
})
export class AppService {

    public loading: Observable<boolean>;
    public isReady: Observable<boolean>;
    public notification: BehaviorSubject<Message> = new BehaviorSubject<Message>(null);

    /**
     * Use component-based dialogs from the UI module for a more robust alternative.
     * @deprecated
     */
    public modal: BehaviorSubject<Modal | string> = new BehaviorSubject<Modal | string>(null);
    
    constructor(
        private router: Router,
        private loaderService: LoaderService,
        private hippoContentService: HippoContentService,
        private authService: AuthService,
        private store: Store<ContentState>
    ) {
        
        /**
         * The isReady state determines if the app is ready to be rendered to the user.
         * Typically this is when the user is authorized and the content labels are loaded.
         */
        this.isReady = this.store.select(state => state.labels).pipe(
            map(labels => this.authService.isAuthorized() && Object.keys(labels).length > 0)
        );
        
        this.hippoContentService.hasLabelsFallback.subscribe(hasLabelsFallback => {
            if (hasLabelsFallback) {
                this.notification.next(new InformationMessage(ERROR_NO_LABELS, null, null, null, true));
            }
        });
        
        /**
         * The loading state will depend on the presence of one or more loaders
         */
        this.loading = this.loaderService.loaders.pipe(
            map(loaders => loaders.length > 0)
        );
        
        /**
         * Non-persistent notifications will be cleared after each next router navigation event
         */
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart && this.notification.value && this.notification.value.persistent === false) {
                this.notification.next(null);
            }
        });
    }
    get language(): string {
        return LANGUAGE_DEFAULT;
    }

    get hash(): string {
        const src = (document.scripts[document.scripts.length - 1]).src;
        const chunks = src.split('.');
        return chunks[chunks.length - 2] || '';
    }

    reload(): void {
        window.location.reload();
    }


}
